/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Kits_HintInputs */

const en_fw_kits_hint = /** @type {(inputs: Fw_Kits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One click fills the box below. Edit it before you send — the kit is a starting point, not a cage.`)
};

const id_fw_kits_hint = /** @type {(inputs: Fw_Kits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekali klik, kotak di bawah terisi. Ubah dulu sebelum kamu kirim — kit itu titik awal, bukan pagar.`)
};

/**
* | output |
* | --- |
* | "One click fills the box below. Edit it before you send — the kit is a starting point, not a cage." |
*
* @param {Fw_Kits_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_hint = /** @type {((inputs?: Fw_Kits_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_hint(inputs)
	return en_fw_kits_hint(inputs)
});